module.exports = "/assets/07dbf5108b79fa573b006263de432831.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MM.png
// module id = 1619
// module chunks = 0